import { FieldState, FormState } from 'formstate'
import { cantBeNegative, cantBeZero, onlyNumeric, required } from '../../utils/forms'

class SendCreditForm {
  fields = {
    amount: new FieldState('').validators(required, onlyNumeric, cantBeZero, cantBeNegative),
  }

  form = new FormState(this.fields)

  serialize = () => {
    return {
      amount: this.fields.amount.$,
    }
  }
}

export { SendCreditForm }
